/* eslint-disable import/order */
import useI18n from '@i18n';
import React from 'react';

import notification from 'epn-ui/umd/dist/components/Notification';

import { AMPLITUDE_EVENTS_KEYS, logAmplitudeEvent } from 'src/utils/metrics/amplitude';
import sendGaEvent from 'src/utils/metrics/ga';

import { EXPORT_FORMATS } from '@pages/offers/config';
import Menu from 'epn-ui/umd/dist/components/Menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/pro-regular-svg-icons/faArrowDown';
import styles from './index.module.scss';

interface IExportButton {
    disabled: boolean;
    onExportOffers: (exportFormat: string) => void;
}

const ExportButton: React.FC<IExportButton> = ({ onExportOffers }) => {
    const { t } = useI18n('Offers');

    const exportOnClick = async (format: string) => {
        if (format === 'default') return;

        notification.info({ message: t('Started to form the export, please wait') });
        sendGaEvent({
            eventCategory: 'offer',
            eventAction: 'export',
            eventLabel: 'fileType',
            eventValue: EXPORT_FORMATS.findIndex(item => item?.value === format) + 1,
        });
        logAmplitudeEvent(AMPLITUDE_EVENTS_KEYS.offersExport);
        onExportOffers(format);
    };

    const items = [
        {
            label: (
                <FontAwesomeIcon
                    icon={faArrowDown}
                    className="border text-blueGray-500 border-blueGray-500 rounded-[6px] py-[11px] px-[4px] h-[40px] !w-[40px]"
                />
            ),
            key: 'SubMenu',
            children: [
                {
                    label: <span className="text-blueGray-600">csv</span>,
                    onClick: () => exportOnClick('csv'),
                },
                {
                    label: <span className="text-blueGray-600">xls</span>,
                    onClick: () => exportOnClick('xls'),
                },
                {
                    label: <span className="text-blueGray-600">xlsx</span>,
                    onClick: () => exportOnClick('xlsx'),
                },
            ],
        },
    ];
    return (
        <div className={styles.export}>
            <Menu mode="horizontal" items={items} triggerSubMenuAction="click" />
        </div>
    );
};

export default ExportButton;
